import React from 'react'

interface Props{
    index:number,
}

interface Regel{
    header:string,
    text:JSX.Element
}

export function GetRegelArray(){
    const regler:Regel[] = [
        {
            header:"1. Blockad av väg till lektionssal är förbjuden om det hindrar eleven från att komma i tid till sin lektion",
            text:<div>
                <p>En blockad är när en mördare med vapen hindrar offret från att komma till sin lektion genom att stå framför lektionsalsdörren.</p>
                <p>Offret måste alltid kunna bevisa med schema att denne har lektion.</p>
            </div>
        },
        {
            header:"2. Inga mord får begås under lektionstid, oavsett var offret befinner sig",
            text:<div>
                <p>Offret måste alltid kunna bevisa med schema att denne har lektion.</p>
                <i><p>Undantag: Schemabrytande lektionstid måste kunna strykas av lärare.</p></i>
                <i><p>Avslutar läraren lektionen tidigare än vad schemat säger så är det inte längre lektion och man kan då bli dödad. (På resurstiden är skolbyggnaden alltid killerfri fram till 16.00)</p></i>
            </div>
        },
        {
            header:"3. Inga mord får begås i matsalen eller lärarens arbetsrum",
            text:<div>
                <p>Matsalen, arbetsrum, grupprum med lås och toaletter får dock inte användas som tillflyktszon.</p>
            </div>
        },
        {
            header:"4. Våld får inte användas för att nå sitt offer eller för att hindra en mördare",
            text:<div><p></p></div>
        },
        {
            header:"5. Under Resurstiden gills hela skolbyggnaden som en lektionssal",
            text:<div>
                <p>På onsdagar klocka 13.45 - 16.00 är det med andra ord killerfritt inne på skolan.</p>
            </div>
        },
        {
            header:"6. Alla mord ska registreras hos oss av både mördare och offer",
            text:<div>
                <p>Detta görs via mail där man skriver: "Namn och klass" dödade "Namn och klass"</p>
            </div>
        },
        {
            header:"7. Man får absolut inte byta offer med någon då detta skulle förstöra cirkeln",
            text:<div>
                <p>Man får heller inte döda någon annan än sitt tilldelade offer</p>
                <p>Bryter man mot någon av dessa regler förstör man för alla andra deltagare</p>
            </div>
        },
        {
            header:"8. Mord får bara begås mellan 7.00 - 20.00",
            text:<div></div>
        },
        {
            header:"9. Mord får inte begås hemma hos offret",
            text:<div>
                <p>Mord får heller inte göras på hemmets tillhörande område som bestäms enligt nedan:</p>
                <ul>
                    <li>Villor och radhus är tillhörande tomt killerfri.</li>
                    <li>Lägenheter är trappuppgång(ar) killerfria.</li>
                </ul>
            </div>
        },
        {
            header:"10. Man får endast försöka döda sitt offer en gång varje minut",
            text:<div></div>
        },
        {
            header:"11. Vid tvistemål som ej kan avgöras kommer ett slumpmässigt beslut tas",
            text:<div>
                <p>Detta gör vi efter att noga gått igenom de enskilda fallen och endast om det är absolut nödvändigt för att spelet ska kunna fortgå.</p>
                <p>Det slumpmässiga valet ska göras genom att singla en slant</p>
            </div>
        },
        {
            header:"12. Matcher, Träningar, Körlektioner och annat som kräver stor koncentration är killerfria under tiden de pågår",
            text:<div>
                <p>Du kan dock bli mördad på väg till en träning eller när du precis slutat.</p>
            </div>
        },
        {
            header:"13. Arbetstid",
            text:<div>
                <p>Under arbetstid kan man varken bli dödad eller döda.</p>
                <p>Offret måste alltid kunna bevisa att han/hon faktiskt jobbar. </p>
            </div>
        },
        {
            header:"14. Luciaträningen",
            text:<div>
                <p>När du är med och tränar inför Lucia räknas det som en vanlig lektion.</p>
            </div>
        },
        {
            header:"15. Flyktvägar",
            text:<div>
                <p>Det är inte tillåtet att använda fönster eller nödutgångar som flyktväg. Tillämpas någon av dessa som flyktväg kommer personen i fråga bli diskad direkt.</p>
            </div>
        },
        {
            header:"16. Olämpligt uppträdande",
            text:<div>
                <p>Det är förbjudet att sätta sig själv eller andra i fara eller hota andra deltagare på något sätt. Brytande mot denna regel kommer resultera i en omedelbar diskning.</p>
            </div>
        },
        {
            header:"17. Frånvaro",
            text:<div>
                <p>Självklart måste man vara hemma om man känner sig sjuk, men frånvaro kommer kontrolleras.</p>
                <p>Om man är borta mer än fyra skoldagar i sträck eller på annat sätt har en återkommande frånvaro utan att kunna styrka sin sjukdom diskas man automatiskt. Vi kommer bli betydligt hårdare på detta under skydd- och vapendagar samt senare i Killer.</p>
            </div>
        },
        {
            header:"18. Studentpoäng",
            text:<div>
                <i>Preliminärt, kan komma att ändras</i>
                <p>Studentpoängen i år kommer delas ut enligt följande:</p>
                <ul>
                    <li>
                        <p>
                            Till de tre klasser i trean som har högst procentuellt antal levande av det totala antalet medlemmar i klassen den 29 november 23:59. Antalet levande i procent ges av formeln: <i>100*Antal levande / Antal i klassen</i>. Notera att antal i klassen inte gäller antal anmälda, utan antalet i din klass totalt. Om din klass har 30 elever och 6 levande betyder det alltså 20 procent av din klass lever.
                        </p>
                    </li>
                    <li>
                        <p>
                            Till de tre klasser i trean som har flest kills per person i klassen den 29 november 23:59. Kills per person i klassen bestäms enligt följande: <i>Antal kills av klassen / Antal i klassen</i>. Notera att antal i klassen inte gäller antal anmälda, utan antalet i din klass totalt. Om din klass har 28 elever och 30 kills så har klassen jämförelsetalet 30/26 = ~1.11.
                        </p>
                    </li>
                </ul>
            </div>
        },
        {
            header:"19. Automatisk diskning och ändring av cirkeln",
            text:<div>
                <p>Beroende på hur många som lever när KILLER börjar närma sig sitt sluskede, kan eventuellt filter komma att tillämpas. Ett exempel på ett sådant filter kan vara att alla som dödat färre än x person(er) åker ut ett visst datum.</p>
                <p>Om det bedöms möjligt att Killer kommer bli klart för tidigt, eller liknande misstanke, kan cirkeln komma att göras om för att förlänga spelets gång.</p>
            </div>
        },
        {
            header:"KILLER-ansvariga har alltid sista ordet i eventuella tvister.",
            text:<div></div>
        },
        {
            header:"",
            text:<div>
                <p>Eventuella frågor tas upp med oss via mail (enskildakiller@gmail.com) alternativt Instagram (@enskildakaren).</p>
                <p>Årets KILLER-ansvariga är Elvin (NA19B), Selma (SA19B), Edwin (EK19A) och Alva (NA19A). </p>
            </div>
        }
    ]

    return regler;
}

function GetCorrectRule(index:number){
    let regler = GetRegelArray();

    if(index >= regler.length){
        return regler[0];
    }

    return regler[index];
}

function RegelKiller({index}:Props) {
    return (
        <div className={`Regel ${index % 2 === 0 ? "RegelEven" : "RegelOdd"}`}>
            <h2>
                <strong>
                    {GetCorrectRule(index).header}
                </strong>
            </h2>
            {GetCorrectRule(index).text}
        </div>
    )
}

export default RegelKiller
